
import Vue from "vue";
import { Component, Prop, Inject } from "vue-property-decorator";
import { ControlsTreeContext, Control } from "@/types/controls";
import { clear } from "@/lib/controls/values";
import {
  canPasteControlSectionPropertiesData,
  copyControlSectionPropertiesData,
  pasteControlSectionPropertiesData
} from "@/lib/copy-paste/control-section-properties-data";

@Component({
  components: {}
})
export default class ControlsTreeExpansionPanels extends Vue {
  @Prop()
  control!: Control;

  @Prop()
  path!: string;

  @Inject("context") readonly context!: ControlsTreeContext;

  canPaste = false;

  mounted() {
    this.updateCanPaste();
  }

  async updateCanPaste() {
    const canPaste = await canPasteControlSectionPropertiesData(
      this.path,
      this.control
    );

    this.canPaste = canPaste;
  }

  clearStyles() {
    clear(this.path, this.control, this.context);
  }

  async copyPropertiesData() {
    await copyControlSectionPropertiesData(
      this.path,
      this.control,
      this.context
    );
    this.updateCanPaste();
  }

  async pastePropertiesData() {
    await pasteControlSectionPropertiesData(
      this.path,
      this.control,
      this.context
    );
  }
}
